import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Field, change } from "redux-form";

import { CustomDropdownById } from "components";
import { required } from "validators/validation";

import InlineEditableField from "./inlineEditableField";

import { ReactComponent as WarningIcon } from "static/images/warning-alert.svg";
import styles from "../../merchantInfo.module.scss";

const FORM_NAME = "merchantForm";

const EditInformationFieldForm = ({
	label,
	nameField,
	dropdownItems,
	initialValue,
	isLoading,
	onSubmit,
	isEditable,
}) => {
	const dispatch = useDispatch();

	const setInitialValue = useCallback(
		() => dispatch(change(FORM_NAME, nameField, String(initialValue?.id))),
		[dispatch, initialValue?.id, nameField],
	);

	useEffect(() => {
		setInitialValue();
	}, [setInitialValue]);

	const items = useMemo(
		() =>
			dropdownItems?.map(ddlValue => {
				return {
					name: ddlValue.name,
					id: ddlValue.id,
				};
			}),
		[dropdownItems],
	);

	return (
		<InlineEditableField
			label={label}
			value={initialValue?.name}
			loading={isLoading}
			submitForm={onSubmit}
			onEditCancel={setInitialValue}
			isEditable={isEditable}
			component={
				<Field
					tabIndex="1"
					component={CustomDropdownById}
					validate={[required]}
					name={nameField}
					loading={isLoading}
					items={items}
					smSelect={12}
					wrapperClassName={styles.wrappDdl}
					warningIcon={
						<WarningIcon
							className="text-warning"
							width="10"
							style={{
								margin: "0 5px 4px 0",
							}}
						/>
					}
				/>
			}
		/>
	);
};

export default EditInformationFieldForm;
